<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <h1 class="vtz-h1" id="main-title" i18n>Poll Actions</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        Go to "POLL RESULTS" to see the list of poll results to date.
      </p>
      @if(ballotListService.isActionable(poll)) {
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Go to "MODIFY RESPONSES" to submit another response to this poll.
        </p>
      }
      <div id="vtz-actions" class="vtz-actions">
        <div id="button-group" class="dialog-button-container">
          <button id="back-to-dashboard" class="button-primary" (click)="backToDashboard()" i18n="Button label">
            BACK
          </button>
          <button id="go-to-result-list" class="button-primary" (click)="toResultList()" i18n="Button label">
            POLL RESULTS
          </button>
          @if(ballotListService.isActionable(poll)) {
            <button id="go-to-poll" class="button-primary" (click)="vote()" i18n="Button label">
              MODIFY RESPONSES
            </button>
          }
        </div>
      </div>
    </main>
  </div>
</div>
@if (displaySpinner) {
  <div class="progressSpinner">
    <mat-spinner [diameter]="300" color="primary"></mat-spinner>
    <div class="spinner-warning">
      <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
    </div>
  </div>
}
